import axios from "axios";
import store from "../../store";

async function makeDeleteRequest({
  route = "",
  forceToken = true,
  redirectSuccessPath = "",
  data = "",
}) {
  const apiUrl = import.meta.env.VITE_API_URL;
  const apiEndpoint = `${apiUrl}${route}`;

  // Check for authentication if it is required
  const state = store.getState();
  const token = state.token;

  if (forceToken && !token) {
    console.error("Token is required but not found.");
    return { data: null, error: "Token is required but not found." };
  }

  try {
    const config = {
      withCredentials: true,
      ...(data && { data: data }), // Add `data` only if it exists
    };
    const response = await axios.delete(apiEndpoint, config);
    if (redirectSuccessPath) {
      window.location.replace(redirectSuccessPath);
    }
    return { data: response.data, error: null }; // Return the response data
  } catch (error) {
    const backendErrorMessage =
      error.response && error.response.data && error.response.data.message
        ? error.response.data.message
        : "okänt fel"; // Fallback error message
    return { data: null, error: backendErrorMessage };
  }
}

export default makeDeleteRequest;
